import { Fragment } from "react";
import Card from "../UI/Card";
import classes from "./Article.module.css";

import photo from "../../assets/selfie/selfie.JPG";
import certificate from "../../assets/selfie/dyplom.jpg";
import statue from "../../assets/selfie/statue.jpg";

const selfie1 = `Platforma selfie+ to miejsce stworzone między innymi dla beneficjentów programu Erasmus+. Od kilku lat na platformie 
organizowany jest konkurs fotograficzny Selfie+, który daje beneficjentom programów realizowanych przez Fundację Rozwoju Systemu Edukacji (FRSE) możliwość podzielenia się efektami swojej pracy.`;

const selfie2 = `W ROKU 2019 NASZE SELFIE ZDOBYŁO 1 MIEJSCE W KATEGORII „TWÓJ PROJEKT W JEDNYM UJĘCIU“!!`;

const SelfieArticle = (props) => {
  return (
    <Fragment>
      <p className="main"></p>
      <Card>
        <div>
          <h1 className={classes.header}>
            Zdobyliśmy 1 miejsce w konkursie SELFIE+!!!
          </h1>
          <p className={classes.text}>{selfie1}</p>
          <p className={classes.text}>{selfie2}</p>
          <img className={classes.image} src={photo} alt="" />
          <p className={classes.center}>Zwycięskie zdjęcie / Winning Selfie</p>
        </div>
        <br />
        <div className={`${classes.images} ${classes.center}`}>
          <article>
            <img className={classes.image} src={certificate} alt="" />
            <p className={classes.center}>Dyplom dla zwycięzców</p>
          </article>
          <article>
            <img className={classes.image} src={statue} alt="" />
            <p className={classes.center}>Statuetka</p>
          </article>
        </div>
      </Card>
    </Fragment>
  );
};

export default SelfieArticle;
